import { SectionCard, SectionCardTitle } from "@/components";
import { WhyChoose } from "./WhyChoose";
import { Certification } from "./Certification";
import { Vision } from "./Vision";
import { Mission } from "./Mission";
import { ResearchAndDevelopment, ManufacturingFacility } from "./Manufacturing";
import OverviewImageGrid from "./ImageGrid";
import { Meta } from "@/components";

const Overview = () => {
  return (
    <>
      <Meta
        title="Intron - Overview"
      />
      <SectionCard className="px-4 lg:px-[90px] mx-0 h-auto">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
          <div className="lg:w-1/2 w-full lg:mt-25">
            <SectionCardTitle>Overview</SectionCardTitle>
            <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px]  text-justify   text-[#415667] mt-4">
              With a commitment to scientific rigor and continuous innovation, Intron Life Sciences provides transformative solutions that improve gut health, immunity, and productivity in livestock, aquaculture, and companion animals.
            </p>
          </div>
          <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
            <div className="w-fit">
              <OverviewImageGrid />
            </div>
          </div>

        </div>
      </SectionCard>
      {/* <WhyChoose/>
    <Certification/> */}
      <Vision />
      <Mission />
      <ResearchAndDevelopment />
      <ManufacturingFacility />
    </>
  );
};

export default Overview;
